import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ShoppingBag1"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M9.92452 12.4518C9.34358 11.7547 9 10.7843 9 9.75H7.5C7.5 11.1026 7.9466 12.4214 8.77218 13.4121C9.60109 14.4068 10.7578 15 12 15C13.2422 15 14.3989 14.4068 15.2278 13.4121C16.0534 12.4214 16.5 11.1026 16.5 9.75H15C15 10.7843 14.6564 11.7547 14.0755 12.4518C13.4979 13.145 12.7469 13.5 12 13.5C11.2531 13.5 10.5021 13.145 9.92452 12.4518Z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.6307 1.5H18.3693L21.75 5.89491V22.5H2.25016L2.25 5.89491L5.6307 1.5ZM3.75014 21H20.25V6.75H3.75001L3.75014 21ZM4.63853 5.25H19.3615L17.6307 3H6.3693L4.63853 5.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ShoppingBag1.vue"]]);
